import { ArrowDecisionIcon } from './ArrowDecisionIcon';

/**
 * author: Michael Richins
 * id 61D65F86-CEB6-4CCC-8B88-00A4D0AD37C4
 * name arrow-decision
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-decision.svg
 * tags
 * - Arrow 
 */
export const ProxyIcon = ArrowDecisionIcon;
export default ProxyIcon